import { useState } from "react";
import { createPortal } from "react-dom";
import { SpecialOfferProps } from "./types";
import { useSpecialOfferData } from "./hooks";
import { SpecialOfferLanding } from "./special-offer-landing";
import { SpecialOfferComponent } from "./special-offer-component";
import { getLandingSettingsFromSpecialList } from "./utils";

export const SpecialOffer = ({
  name,
  type,
  analyticsSettings,
  className,
  dataTestId,
}: SpecialOfferProps) => {
  const { data: specialOfferList } = useSpecialOfferData(name, type);

  const [isOpenedSpecialLanding, setOpenedSpecialLanding] = useState(false);

  const openSpecialLanding = () => {
    setOpenedSpecialLanding(true);
  };

  const closeSpecialLanding = () => {
    setOpenedSpecialLanding(false);
  };

  if (!specialOfferList?.length) {
    return null;
  }

  return (
    <>
      <div className={className}>
        <SpecialOfferComponent
          type={type}
          data={specialOfferList[0]}
          analyticsActionName={analyticsSettings?.actionName}
          clientInn={analyticsSettings?.clientInn}
          onClick={openSpecialLanding}
          dataTestId={dataTestId}
        />
      </div>
      {createPortal(
        <SpecialOfferLanding
          onClose={closeSpecialLanding}
          isOpened={isOpenedSpecialLanding}
          clientInn={analyticsSettings?.clientInn}
          data={getLandingSettingsFromSpecialList(specialOfferList)}
        />,
        document.body
      )}
    </>
  );
};
